export default "__VITE_ASSET__CZSw38Di__"